import app from "nystem";
import { Wrapper } from "nystem-components";

const OverlayOpen = ({ overlayId, className, accessibilityLabel, accessible, children }) => (
  <Wrapper
    accessibilityLabel={accessibilityLabel}
    accessible={accessible}
    renderAs="button"
    type="button"
    aria-label={accessibilityLabel || "Öppna meny"}
    className={className}
    onClick={(event) => {
      event.preventDefault();
      app.event("overlay", { overlayId, do: "open" });
    }}
  >
    {children}
  </Wrapper>
);
export default OverlayOpen;
